import { Huddle, HuddleStatus, Request } from 'lib/generated/graphql';
import React from 'react';
import ProjectDurations from 'src/screens/my-projects/components/projectDurations';
import { EditButton, Tag } from 'src/shared-components';

const HuddleTags = ({
  request,
  huddle,
  openModal,
  showIndustries = false,
  isCurrentUserAllowedToEdit = false,
  showEditButton = false,
}: {
  request: Request;
  huddle?: Huddle;
  showIndustries?: boolean;
  isCurrentUserAllowedToEdit?: boolean;
  showEditButton?: boolean;
  openModal?: (modal: string) => void;
}) => {
  const allTags = () => {
    let tags = [];
    tags = [...request?.company?.tags?.filter(tag => tag.shown)];
    if (request?.preferredDuration) tags = [{ slug: 'time duration', value: `⏳ ${ProjectDurations[request?.preferredDuration - 1]?.label} project`, shown: true }, ...tags];
    if (request?.equityOrCrypto) tags = [{ slug: 'partial-equity', value: '💸 Partial Equity', shown: true }, ...tags];
    if (huddle && huddle?.status === HuddleStatus.TeamForming) {
      tags = [{ slug: 'team-forming', value: `⚡ Team Forming`, shown: true }, ...tags];
    }
    if (showIndustries) {
      tags = [
        ...tags,
        ...request?.company?.industry.map(industry => ({ slug: industry, value: industry, shown: true })),
      ];
    }
    return tags;
  };

  return (
    <div className="mb-4 flex">
      <ul>
        {allTags().map(tag => {
          if (!tag.shown) return null;
          let color;
          if (tag.value === '💸 Partial Equity') color = 'green';
          else if (tag.value === '⚡ Team Forming') color = 'yellow';
          else if (tag.value.startsWith('⏳')) color = 'blue';
          else color = 'white';
          return (
            <li key={tag.slug} className="mr-2 w-fit inline-block mb-2 sm:mb-0 mt-2">
              <Tag text={tag.value} size="md" color={color} roundness="full" />
            </li>
          );
        })}
      </ul>
      {isCurrentUserAllowedToEdit && showEditButton && <EditButton onClick={() => openModal('budget')} />}
    </div>
  );
};

export default HuddleTags;
